<p-toast
  class="flex w-[380px] max-w-[calc(100vw-2rem)] flex-col gap-3"
  position="bottom-right"
  [baseZIndex]="9999"
>
  <ng-template pTemplate="headless" let-message let-closeFn="closeFn">
    <div
      class="flex w-full items-start gap-3 rounded-surface border p-3.5 shadow-overlay"
      [class]="toneClass(message.severity)"
    >
      <mat-icon class="icon-md mt-0.5 shrink-0" aria-hidden="true">
        {{ iconFor(message.severity) }}
      </mat-icon>

      <div class="flex min-w-0 flex-1 flex-col gap-0.5">
        <span class="text-sm leading-snug font-semibold">{{ message.summary }}</span>
        @if (message.detail) {
          <span class="text-xs leading-snug">{{ message.detail }}</span>
        }
      </div>

      <button
        type="button"
        class="inline-flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-control opacity-70 transition hover:bg-current/10 hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        aria-label="Cerrar notificación"
        (click)="closeFn($event)"
      >
        <mat-icon class="icon-sm" aria-hidden="true">close</mat-icon>
      </button>
    </div>
  </ng-template>
</p-toast>
